import React from 'react';
import cx from 'classnames';
import withStyles from '@mui/styles/withStyles';
import Grid from '../layout/Grid';
import Label from './Label';

const ReadonlyField = ({ label, children, className, validationClass }) => (
    <div className="readonly">
        <Grid container spacing={1} margin={false}>
            {label && (
                <Grid item>
                    <Label className={cx(`form-label`, className, validationClass)}>{label}</Label>
                </Grid>
            )}
            <Grid item>
                <span className={cx('value', validationClass)}>{children}</span>
            </Grid>
        </Grid>
    </div>
);

export default withStyles({})(ReadonlyField);
